module.exports = __webpack_public_path__ + "img/person-white.5ae907e9.svg";